module.exports = __webpack_public_path__ + "img/20.44a26ac2.jpg";